export default __webpack_public_path__ + "static/media/fondo2.30825e1b.png";